var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AntDrawer',{attrs:{"width":"350px","placement":_vm.type,"visible":_vm.visible,"get-container":false,"wrap-style":{ position: 'absolute' },"maskStyle":{
    background: 'none'
  }},on:{"close":_vm.close}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }